import * as React from "react";

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PaymentsIcon from '@mui/icons-material/Payments';

const iconStyle = { width: "20px", height: "20px", verticalAlign: "middle"};
export const UserHistoryTypeEnumIcons = [
  {
    id: "sales",
    name: "Sales",
    icon: <PaymentsIcon color="primary" sx={iconStyle} />,
  },
  {
    id: "general",
    name: "General",
    icon: <AccountCircleIcon color="primary" sx={iconStyle} />,
  }
];